import { CartSummaryA } from './CartSummaryA';
import { CartPageProps } from './pages/CartPage';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface CartSummaryProps extends CartPageProps {}

export type CartSummaryVariants = 'A';

const CartSummaryController = (props: PropsWithCustomComponent<CartSummaryProps>) => (
  <VariantsController<CartSummaryProps, CartSummaryVariants>
    {...props}
    variantsControllerConfig={{
      componentVariants: { A: CartSummaryA },
      defaultComponent: CartSummaryA,
      name: 'CartSummary',
    }}
  />
);
export { CartSummaryController as CartSummary };
